import powerAndFuelIcon from '@/assets/icons/power and fuel.svg'
import weatherIcon from '@/assets/icons/weather.svg'
import shieldIcon from '@/assets/icons/shield.svg'
import chatIcon from '@/assets/icons/chat.svg'
import type { IndustryPageContent } from './types'

// Copy: content/unimo-industry-page-copy.md, "TV & FILM" — signed off 28 Aug 2026.
// Stats/citations: content/unimo-industry-stats.md v7 (final) — same date.
//
// Hero headline is the only thing carried over from the old live page at
// src/features/industries/TvFilmPage.tsx — nothing else from it. That page's
// headline read "From Location to ALBERT Report." (all-caps, bare) — corrected
// to "BAFTA Albert" here per the house rule in
// .claude/rules/unimo-design-system.md ("'BAFTA Albert' on first mention...
// never all-caps ALBERT"). This is the first mention on the page, so it takes
// the full form; the USP card below uses "BAFTA Albert" too since each
// USP card is read independently, not as continuous prose with the hero.
//
export const tvFilmContent: IndustryPageContent = {
    key: 'tv-film',
    hero: {
        headlineLine1: 'From Location to BAFTA Albert Report.',
        headlineLine2: 'In Minutes.',
    },
    statBand: {
        header: 'What TV and film crews are up against.',
        stats: [
            {
                figure: '15.3',
                unitPhrase: 'tonnes',
                body: 'of CO2e per hour of television made in 2024. Your commissioning broadcaster will want that number.',
                citation: 1,
            },
            {
                figure: '3',
                unitPhrase: 'million litres',
                body: 'of fuel burnt in generators on location last year. Someone has to account for it.',
                citation: 2,
            },
            {
                figure: '52',
                unit: '%',
                body: "of production carbon data is estimated rather than measured. That's BAFTA Albert's own audit, not ours.",
                citation: 3,
            },
        ],
    },
    usps: [
        {
            title: 'Real-time power monitoring',
            body: 'Non-invasive clamps track generator load, runtime and fuel consumption. See which units are idling and right-size your power.',
            icon: powerAndFuelIcon,
        },
        {
            title: 'Environmental sensors',
            body: 'Track noise levels, temperature, humidity and air quality across your location. Know your impact before complaints arrive.',
            icon: weatherIcon,
        },
        {
            title: 'Automated Albert evidence',
            body: 'Time-stamped, audit-grade data flows directly into your BAFTA Albert reports. No spreadsheets. No guesswork. Proof that holds up.',
            icon: shieldIcon,
        },
        {
            title: 'Ask the site',
            body: '"How much diesel did we use this week?" Just ask. unimo gives you answers in plain English, no training required.',
            icon: chatIcon,
        },
    ],
    closingCta: {
        headline: 'Ready to lose the clipboards?',
    },
    references: [
        {
            id: 1,
            text: 'BAFTA Albert, ACCELERATE 2025, industry data appendix, 2025 (2024 data).',
            italicPhrase: 'ACCELERATE 2025',
            url: 'https://baftaalbert.org/resources/accelerate-2025-report/',
            linkLabel: 'baftaalbert.org',
        },
        {
            id: 2,
            text: 'BAFTA Albert, ACCELERATE 2025, energy chapter, 2025 (2024 data).',
            italicPhrase: 'ACCELERATE 2025',
            url: 'https://baftaalbert.org/resources/accelerate-2025-report/',
            linkLabel: 'baftaalbert.org',
        },
        {
            id: 3,
            text: 'BAFTA Albert, ACCELERATE 2025, tracking chapter, 2025 (2024 data).',
            italicPhrase: 'ACCELERATE 2025',
            url: 'https://baftaalbert.org/resources/accelerate-2025-report/',
            linkLabel: 'baftaalbert.org',
        },
    ],
}

export default tvFilmContent
